module.exports = __webpack_public_path__ + "static/media/exclamation-circle.3584042a.svg";